import appConfig from "config.json";
import { isCurrentPathPresent, toggleBodyClass } from "utils";
import { defaultThemeVariant } from "config-txp";
import { getParam, validateBodyClasses } from "./paramsValidation";

const navFloatConfig = {
	checkoutExpressPage: ["checkoutConfirmationPage"],
	"help-and-faq-background": ["hyperion"],
};

const navFloatMultiClassConfig = [["cart", "STORE_VWCNFG_STYLES_WDW", "pepde"]];
const navFloatClass = "nav-float";
const navGradientClass = "nav-gradient";

export const isNavFloat = () => validateBodyClasses(navFloatClass);
export const isNavGradient = () => validateBodyClasses(navGradientClass);

let navFloatAppliedByUs = false;
let navGradientAppliedByUs = false;

const getTxpConfig = (brand, environment) => {
	const envConfig =
		appConfig.environmentConfiguration?.[environment]?.txp?.[brand] || {};
	const brandConfig = appConfig.brands?.[brand]?.txp || {};
	return { ...brandConfig, ...envConfig };
};

const isPageInTxpList = (brand, environment, key, updatedLocation) => {
	const txpConfig = getTxpConfig(brand, environment);
	const pages = txpConfig?.[key] || [];
	return pages.length > 0 && isCurrentPathPresent(pages, updatedLocation);
};

export const applyNavFloatClass = (brand, environment, updatedLocation) => {
	const shouldApplyByBodyClass = Object.entries(navFloatConfig).some(
		([requiredClass, excludedClasses]) =>
			validateBodyClasses(requiredClass) &&
			!excludedClasses.some(validateBodyClasses)
	);

	const shouldApplyByMultiClass = navFloatMultiClassConfig.some((classGroup) =>
		classGroup.every(validateBodyClasses)
	);

	const shouldApplyByPage = isPageInTxpList(
		brand,
		environment,
		"navFloatPages",
		updatedLocation
	);
	const shouldApply =
		shouldApplyByBodyClass || shouldApplyByMultiClass || shouldApplyByPage;

	if (shouldApply && !navFloatAppliedByUs) {
		toggleBodyClass(true, navFloatClass);
		navFloatAppliedByUs = true;
	} else if (!shouldApply && navFloatAppliedByUs) {
		toggleBodyClass(false, navFloatClass);
		navFloatAppliedByUs = false;
	}
};

const availableThemes = { light: "nav-light", dark: "nav-dark" };
// Function to get theme key from theme value
export const getThemeKey = (themeValue) => {
	return Object.keys(availableThemes).find(
		(key) => availableThemes[key] === themeValue
	);
};

export const shouldInvertItems = (isTxp) =>
	getThemeKey(isTxp) !== defaultThemeVariant;

const getTxpConfigTheme = (brand, locale, environment, updatedLocation) => {
	const txpConfig = getTxpConfig(brand, environment);

	if (
		!txpConfig?.enabled ||
		(txpConfig.allowedLocales && !txpConfig.allowedLocales.includes(locale))
	) {
		return null;
	}

	return !isCurrentPathPresent(txpConfig.darkThemePages || {}, updatedLocation)
		? availableThemes.light
		: availableThemes.dark;
};

export const applyNavGradientClass = (brand, environment, updatedLocation) => {
	const shouldApply = isPageInTxpList(
		brand,
		environment,
		"navGradientPages",
		updatedLocation
	);

	if (shouldApply && !navGradientAppliedByUs) {
		toggleBodyClass(true, navGradientClass);
		navGradientAppliedByUs = true;
	} else if (!shouldApply && navGradientAppliedByUs) {
		toggleBodyClass(false, navGradientClass);
		navGradientAppliedByUs = false;
	}
};

export const getTXPtheme = (brand, locale, environment, updatedLocation) => {
	if (!appConfig?.txpAllowedBrands?.includes(brand)) return false;
	const theme =
		window?.localStorage.getItem("data-nav-theme") ||
		new URLSearchParams(window.location.search).get("dataNavTheme") ||
		getTxpConfigTheme(brand, locale, environment, updatedLocation);

	if (!theme || !Object.values(availableThemes).includes(theme)) return false;

	// We should not replace the current assigned theme here
	if (!document.body.dataset.navTheme) {
		document.body.dataset.navTheme = theme;
	}

	applyNavGradientClass(brand, environment, updatedLocation);
	applyNavFloatClass(brand, environment, updatedLocation);

	return theme;
};

export const recalculateTxpClasses = (
	brand,
	locale,
	environment,
	updatedLocation
) => {
	if (!appConfig?.txpAllowedBrands?.includes(brand)) return;

	const theme = getTxpConfigTheme(brand, locale, environment, updatedLocation);
	if (theme && Object.values(availableThemes).includes(theme)) {
		document.body.dataset.navTheme = theme;
	}

	applyNavGradientClass(brand, environment, updatedLocation);
	applyNavFloatClass(brand, environment, updatedLocation);
};

export const getSearchAutocompleteEnginte = () => {
	const searchEngineParam = getParam("searchEngine");

	const searchEngineLocalStorage = window?.localStorage.getItem("searchEngine");

	return searchEngineParam || searchEngineLocalStorage;
};
